import React from 'react';
import LoginContainer from '../components/Login/LoginContainer';

const Login = () => {
  return (
    <div>
      <LoginContainer />
    </div>
  );
};

export default Login;
